<section
  [ngClass]="{
    'bg-grey': backgroundColor === 'grey',
    'padding-top': paddingTop,
    'padding-bottom': paddingBottom,
    'no-padding-block': !paddingBlock,
  }"
  [attr.id]="mainSection?.formData?.st_anchor_name?.value ?? id"
  [attr.data-preview-id]="mainSection?.identifier"
>
  <div class="container">
    <ng-content></ng-content>
    <ng-container *ngIf="orderedComponents.length > 0">
      <div data-preview-id="#st_items">
        <ng-container *ngFor="let component of orderedComponents; let i = index">
          <ng-container [ngSwitch]="component.template.uid" >
            <div [attr.data-preview-id]="'#'+i" style="padding-block: 1rem;">
          <!-- Text Block -->
          <hdi-text-block
            *ngSwitchCase="'text'"
            [caasData]="component"
            [sectionBackgroundColor]="backgroundColor"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-text-block>
          <hdi-text-block
            *ngSwitchCase="'st_text'"
            [caasData]="component"
            [sectionBackgroundColor]="backgroundColor"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-text-block>

          <!-- Static Graphic -->
          <hdi-static-graphic
            *ngSwitchCase="'st_image'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-static-graphic>
          <hdi-static-graphic
            *ngSwitchCase="'bild_grafik'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-static-graphic>

          <!-- Highlight Cards -->
          <hdi-highlightcard-list
            *ngSwitchCase="'st_highlights'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-highlightcard-list>

          <!-- News -->
          <hdi-teaser-container
            *ngSwitchCase="'st_news'"
            [columns]="
              component.formData.st_quantity?.value?.identifier === ''
                ? 3
                : component.formData.st_quantity?.value?.identifier === '6'
                  ? 6
                  : 9
            "
            [caasNewsData]="component"
            [type]="'news'"
            [sectionBackgroundColor]="backgroundColor"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-teaser-container>

          <!-- Help Disruptor -->
          <hdi-help-disruptor
            *ngSwitchCase="'st_helpdisruptor'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-help-disruptor>
          <!-- Accordion -->
          <ng-container *ngSwitchCase="'st_accordion'">
            <hdi-accordion
              [caasData]="component"
              [isSectionBg]="backgroundColor !== 'white'"
              [id]="component.formData.st_anchor_name?.value"
            ></hdi-accordion>
          </ng-container>
          <!-- Teasers -->
          <ng-container *ngSwitchCase="'st_teasers'">
            <ng-container *ngIf="translatedComponents?.teasers?.length">
              <hdi-teaser-container
                [caasData]="component"
                [id]="component.formData.st_anchor_name?.value"
                [type]="'standard'"
                [sectionBackgroundColor]="backgroundColor"
              >
              </hdi-teaser-container>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'st_teasers_temp'">
            <ng-container *ngIf="translatedComponents?.teasers?.length">
              <hdi-teaser-container
                [caasData]="component"
                [id]="component.formData.st_anchor_name?.value"
                [type]="'standard'"
                [sectionBackgroundColor]="backgroundColor"
              >
              </hdi-teaser-container>
            </ng-container>
          </ng-container>
          <!-- Downloads -->
          <hdi-material-download
            *ngSwitchCase="'st_downloads'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          >
            <div #slot *ngIf="materialDownloadInclude">
              <ng-container *ngFor="let deepLink of materialDownloadDeepLinks">
                <hdi-cross-referencing
                  [caasData]="deepLink"
                  [isSectionBg]="backgroundColor !== 'white'"
                ></hdi-cross-referencing>
              </ng-container>
            </div>
          </hdi-material-download>

          <!-- Cross Referencing -->
          <ng-container *ngIf="!materialDownloadInclude">
            <hdi-cross-referencing
              *ngSwitchCase="'st_deeplink'"
              [caasData]="component"
              [id]="
                component.formData.st_anchor_name?.value ??
                component.formData.id
              "
              [isSectionBg]="backgroundColor !== 'white'"
            ></hdi-cross-referencing>
          </ng-container>
          <!-- Trusted Awards -->
          <hdi-slider
            *ngSwitchCase="'st_awards'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-slider>
          <hdi-slider
            *ngSwitchCase="'st_trusted_awards'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-slider>

          <!-- Contact Module -->
          <hdi-contact-module
            *ngSwitchCase="'contact'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-contact-module>
          <hdi-contact-module
            *ngSwitchCase="'st_contact'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-contact-module>

          <!-- Podcasts -->
          <ng-container *ngSwitchCase="'st_podcasts'">
            <ng-container
              *ngIf="
                component.formData?.st_layout?.value?.identifier === 'hub' ||
                component.formData?.st_layout?.value?.identifier === 'section'
              "
            >
              <hdi-podcast
                [caasData]="component"
                [isSectionBg]="backgroundColor === 'grey'"
                [id]="
                  component.formData.st_anchor_name?.value ||
                  component.formData.id?.toString()
                "
              ></hdi-podcast>
            </ng-container>
          </ng-container>
          <!-- Podcast Platforms -->
          <hdi-logo-wall
            *ngSwitchCase="'st_podcast_platforms'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-logo-wall>

          <!-- Explanations -->
          <ng-container *ngSwitchCase="'st_infoteasers'">
            <hdi-info-teasers
              [caasData]="component"
              [id]="
                component.formData.st_anchor_name?.value ??
                component.formData.id
              "
            ></hdi-info-teasers>
          </ng-container>

          <!-- Link Tiles -->
          <hdi-utilities-cards
            *ngSwitchCase="'st_linktiles'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
            [headlineSize]="Headlines.H3"
            [sectionBg]="backgroundColor"
          ></hdi-utilities-cards>

          <!-- Prefooters -->
          <hdi-prefooter
            *ngSwitchCase="'st_prefooter'"
            [caasData]="component"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
            [sectionBg]="backgroundColor"
          ></hdi-prefooter>

          <!-- Events -->
          <hdi-termine
            *ngSwitchCase="'st_events'"
            [eventsData]="eventsData"
            [caasData]="component"
            [isSectionBg]="backgroundColor === 'grey'"
            [id]="
              component.formData.st_anchor_name?.value ?? component.formData.id
            "
          ></hdi-termine>

          <!-- Quotes -->
          <ng-container *ngSwitchCase="'st_quotes'">
            <hdi-quote
              *ngIf="
                component.formData.st_items?.value?.length === 1;
                else quoteSlider
              "
              [caasData]="component"
              [id]="
                component.formData.st_anchor_name?.value ??
                component.formData.id
              "
            ></hdi-quote>
            <ng-template #quoteSlider>
              <hdi-slider
                [caasData]="component"
                [id]="
                  component.formData.st_anchor_name?.value ??
                  component.formData.id
                "
              ></hdi-slider>
            </ng-template>
          </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</section>
